import { useTranslation } from 'react-i18next';
import NumberingCard from '../../components/settings/numbering-card.tsx';
import { SettingsLeafPage } from '../../components/settings/settings-leaf-page.tsx';

/** Settings › Pricing & quotes › Quote & invoice numbering: only this card, so only its reads run. */
export default function PricingNumberingPage() {
  const { t } = useTranslation();
  return (
    <SettingsLeafPage
      title={t('settings.pricingPages.tiles.numbering.title')}
      back={{ to: '/settings/pricing', label: t('settings.pricingPages.backToPricing') }}
    >
      <NumberingCard />
    </SettingsLeafPage>
  );
}
